'use client'

import { Locale, useLocale } from 'next-intl'
import { useEffect, useState } from 'react'

const getTimeDifference = (deadline: string) => {
  const now = new Date()
  const end = new Date(deadline)

  let diff = Math.max(0, Math.floor((end.getTime() - now.getTime()) / 1000)) // 초 단위

  const hours = Math.floor(diff / 3600)
  diff %= 3600
  const minutes = Math.floor(diff / 60)
  const seconds = diff % 60

  return {
    hours,
    minutes,
    seconds,
  }
}

type Props = {
  time: string
  onEnd?: () => void
  format: ({
    hours,
    minutes,
    seconds,
    locale,
  }: {
    hours: number
    minutes: number
    seconds: number
    locale?: Locale
  }) => string
}

export const useTimer = ({ time, onEnd, format }: Props) => {
  const locale = useLocale()

  const [timeLeft, setTimeLeft] = useState(
    format({ hours: 0, minutes: 0, seconds: 0, locale }),
  )

  const handleTimerEnd = (timerId: NodeJS.Timeout) => {
    onEnd?.()
    clearInterval(timerId)
  }

  useEffect(() => {
    setTimeLeft(format({ ...getTimeDifference(time), locale }))

    const timer = setInterval(() => {
      const timeDifference = getTimeDifference(time)
      setTimeLeft(format({ ...timeDifference, locale }))

      if (
        timeDifference.hours === 0 &&
        timeDifference.minutes === 0 &&
        timeDifference.seconds === 0
      ) {
        handleTimerEnd(timer)

        return
      }
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [time, locale])

  return { timeLeft }
}
